export default "__VITE_ASSET__369a92d5__"